import React, { useEffect } from 'react'
import { NavBar } from '../../components-pos'

export default function AnalysisIndex(props) {
  useEffect(() => {
    props.history.push('/pos/analysis/sales')
  }, [])
}

export function NavLinks(props) {
  const links = [
    { name: '매출현황', path: '/pos/analysis/sales' },
  ]
  return <NavBar {...props} links={links} />
}
